module.exports = __webpack_public_path__ + "img/6f97036.jpg";